var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo18 = function SvgInfo18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.166 5.598a.834.834 0 1 1 1.667 0 .834.834 0 0 1-1.667 0Zm0 2.5a.834.834 0 0 1 1.667 0v4.166a.834.834 0 0 1-1.667 0V8.098Zm.833 7.5A6.675 6.675 0 0 1 2.333 8.93a6.674 6.674 0 0 1 6.666-6.667 6.674 6.674 0 0 1 6.667 6.667 6.674 6.674 0 0 1-6.667 6.667Zm0-15a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Z",
    fill: "#008545"
  })));
};
export default SvgInfo18;